<template>
  <div class="c-settings-close">
    <el-button class="r-button icon-button" circle @click="clickHandler">
      <r-icon name="close-delete" :size="14" />
    </el-button>
  </div>
</template>

<script>
export default {
  methods: {
    clickHandler() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.c-settings-close {
  position: absolute;
  left: 100%;
  top: 0;
  z-index: 1100;
  height: 36px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2px;

  background-color: var(--bg_panel_secondary) !important;
}
</style>
